import { Component , Input, EventEmitter, Output} from '@angular/core';
import { NgwGame, NgwTeam, NgwPlayer, NgwRound, NgwPick } from '../../app/classes/NgwGame';



@Component({
  selector: 'player-item',
  template: `
    <ion-item [ngClass]="{'unavailable':isAlreadyPicked(player)}" (click)="pickMade.emit(player)">
        <ion-avatar item-left>
            <img [src]="'https://nhl.bamcontent.com/images/headshots/current/168x168/' + player.person.id + '.jpg'">
        </ion-avatar>
        <h2>{{player.person.fullName}}</h2>
        <h3>#{{player.person.primaryNumber}}, {{player.person.primaryPosition.abbreviation}}</h3>
        <p>{{player.person.stats[0]?.splits[0]?.stat.points}}<small>p</small> / {{player.person.stats[0]?.splits[0]?.stat.goals}}<small>g</small> {{player.person.stats[0]?.splits[0]?.stat.assists}}<small>a</small></p>
       
         
    </ion-item>`,
    styles: [
        '.unavailable, .unavailable p  { color: #ccc; }',
        '.unavailable img {filter: grayscale(100%);}'
    ]
})
export class PlayerItem  {
    @Input()
    player: any = null;
    @Input()
    round:NgwRound=null;

    @Output() pickMade: EventEmitter<any> = new EventEmitter();


    isAlreadyPicked(player:any):Boolean 
    {
        if(this.round.picks.find((pick) => pick.nhlPlayer.person.id == player.person.id))
            return true;
        return false;
    }

    playerPicked(player:any)
    {
        if(!this.isAlreadyPicked(player))
        {
            this.pickMade.emit(player);
        }
    }

}




// WEBPACK FOOTER //
// ./src/pages/players/playerItem.ts